/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */

import copyToClipboard from 'copy-to-clipboard'
import { Button } from 'core/components/button'
import { Field } from 'core/components/form/field'
import { TextInput } from 'core/components/form/text-input'
import { AppStoreBadge, GooglePlayBadge } from 'core/components/mobile-link'
import { PlateMask, requiredMessage } from 'core/constants'
import { toLocaleTime } from 'core/helpers/date'
import { maskMoney } from 'core/helpers/mask'
import { useForm } from 'core/hooks/form'
import { CouponPDF } from 'core/utils/pdf'
import { QRCodeSVG } from 'qrcode.react'
import React, { useEffect, useRef, useState } from 'react'
import { API } from 'service'
import { io } from 'socket.io-client'
import { config } from '../../config'
import { Logo } from '../logo'

const getDefaultTime = fees => {
  const fee = fees.find(f => f.minutes === 60)

  if (fee) return fee
  return fees[0]
}

const setDefaultTime = (form, parameters, fees) => {
  const { vehicleTypeRequiredParking, blockRequiredParking } = parameters

  if (!vehicleTypeRequiredParking && !blockRequiredParking) {
    const fee = getDefaultTime(fees)
    form.setValues({
      minutes: fee.minutes,
      value: fee.value,
    })
  }
}

function renderPlate(form, route, cityName) {
  const { entity, errors, touched, handleChange } = form

  const submitPlate = ev => {
    ev.preventDefault()

    if (!touched.plate) {
      handleChange({ path: 'plate', values: {} })
    } else if (touched.plate && !errors.plate) {
      route.history.push(`/${cityName}/estacionar-pix/${entity.plate}`)
    }
  }

  return (
    <form onSubmit={ev => submitPlate(ev)}>
      <Field label="Placa">
        <TextInput
          autoFocus
          customClassName="form-control-lg"
          mask={PlateMask}
          meta={{
            error: errors.plate,
            touched: touched.plate,
          }}
          onChange={(p, type) =>
            handleChange({
              path: 'plate',
              type,
              values: { plate: p.toLocaleUpperCase() },
            })
          }
          value={entity.plate}
        />
      </Field>

      <div className="login-actions">
        <Button
          customClassName="btn-primary btn-lg btn-block"
          icon="fas fa-qrcode"
          title="Pagar com PIX"
        />
      </div>
    </form>
  )
}

function renderTime(form, parkWithPix) {
  const { entity } = form

  return (
    <>
      <Field label="Tarifa">
        <span className="h3 text-brand">{maskMoney(entity.value)}</span>
      </Field>

      <div className="login-actions">
        <Button
          customClassName="btn-primary btn-lg btn-block"
          icon="fas fa-qrcode"
          title="Pagar com PIX"
          onClick={() => parkWithPix()}
        />
      </div>
    </>
  )
}

function renderPix(form, route, qrCodeData, setQrCodeData) {
  const { entity } = form

  return (
    <>
      <Field label="Tarifa">
        <span className="h3 text-brand">{maskMoney(entity.value)}</span>
      </Field>

      <span className="h5">
        Após efetuar o pagamento do PIX, permaneça nesta página para visualizar seu comprovante.
      </span>

      <div className="row justify-content-center my-3">
        <QRCodeSVG className="qrcode" value={qrCodeData.qrCode} />
      </div>

      <h3 className="h5 pix mb-4">{qrCodeData.qrCode}</h3>

      <span className="h5">Expira às {toLocaleTime(qrCodeData.expiresAt, true)}</span>

      <div className="mt-4">
        <Button
          type="button"
          customClassName="btn-success btn-lg btn-block"
          title={qrCodeData.copied ? 'Copiado' : 'Copiar Código Pix'}
          icon={qrCodeData.copied ? 'fas fa-check' : null}
          onClick={() => {
            setQrCodeData(prev => ({ ...prev, copied: true }))
            copyToClipboard(qrCodeData.qrCode)
          }}
        />

        <Button
          customClassName="btn-danger btn-lg btn-block"
          title="Cancelar"
          onClick={() => {
            route.history.goBack()
          }}
        />
      </div>
    </>
  )
}

function renderPixPaid(form, route, modal, qrCodeData, sendEmail) {
  const { entity } = form

  return (
    <>
      <span className="h5 d-block text-center">{entity.plate}</span>

      {qrCodeData.coupon && <pre className="border rounded p-3 mt-4">{qrCodeData.coupon}</pre>}

      <div className="row bg-success text-white p-3 rounded mx-1 my-4 align-items-center">
        <i className="fas fa-check" />
        <div className="ml-2">Pagamento Aprovado</div>
      </div>

      <div className="login-actions">
        <Button
          type="button"
          customClassName="btn-primary btn-lg btn-block"
          title="Enviar via Email"
          icon="fas fa-envelope"
          onClick={() => {
            modal.prompt('E-mail', 'Digite o e-mail para receber o cupom', email => {
              sendEmail(email, qrCodeData.coupon)
            })
          }}
        />

        <Button
          type="button"
          customClassName="btn-success btn-lg btn-block"
          title="Baixar Recibo"
          icon="fas fa-download"
          onClick={() => {
            const doc = new CouponPDF(qrCodeData.coupon.split('\n'))
            doc.download('estacionamento')
          }}
        />

        <Button
          customClassName="btn-secondary btn-lg btn-block"
          icon="fas fa-arrow-left"
          title="Voltar"
          onClick={() => {
            route.history.goBack()
          }}
        />
      </div>
    </>
  )
}

export const ParkingPixForm = ({ global: { cities, modal }, route }) => {
  const { match } = route
  const { city: cityName, plate } = match.params
  const city = cities.find(city => city.name === cityName)
  const socket = useRef(null)

  const [settings, setSettings] = useState({})
  const [qrCodeData, setQrCodeData] = useState({})

  const parkWithPix = () => {
    API.post('parking.pix', entity)
      .then(resp => {
        setQrCodeData({ ...resp, copied: false })
        setValues({ view: 'Pix' })
      })
      .catch(error => modal.alert(error.message))
  }

  const sendEmail = (email, coupon) => {
    API.post('mail.transaction', { id: qrCodeData.id, email, coupon })
      .then(() => {
        modal.alert('Recibo enviado com sucesso!')
      })
      .catch(error => modal.alert(error.message))
  }

  const [parameters, setParameters] = useState({})

  const form = useForm(
    {
      displayName: ent => ent.name,
      initialEntity: {
        cityId: city.id,
        plate: '',
        vehicleTypeId: 0,
        minutes: 0,
        value: 0,
        regionId: 0,
        streetId: 0,
        streetBlockId: 0,
        parkingLotId: 0,
        view: 'Plate',
      },
      validate: values => {
        const errors = {}
        const plate = values.plate.split(/_/).join('')

        if (!plate) {
          errors.plate = requiredMessage
        } else if (plate.length !== 8) {
          errors.plate = 'Digite o número de placa em um formato válido.'
        }

        if (!values.regionId && parameters.regionRequiredParking) {
          errors.regionId = requiredMessage
        }

        if (!values.streetId && parameters.streetRequiredParking) {
          errors.streetId = requiredMessage
        }

        if (!values.streetBlockId && parameters.blockRequiredParking) {
          errors.streetBlockId = requiredMessage
        }

        if (!values.parkingLotId && parameters.parkingLotRequiredParking) {
          errors.parkingLotId = requiredMessage
        }

        return errors
      },
    },
    route,
  )

  const { entity, setValues } = form

  useEffect(() => {
    socket.current = io(config.API_URL || 'http://localhost:5000', {
      addTrailingSlash: false,
      autoConnect: false,
      transports: ['websocket'],
    })

    Promise.all([API.get(`parameter.parking/${city.id}`), API.get('setting.public')]).then(
      ([dataParameters, dataSettings]) => {
        setParameters(dataParameters)
        setSettings(dataSettings)
        setDefaultTime(form, dataParameters, dataParameters.parkingFees)
      },
    )
  }, [])

  useEffect(() => {
    setValues({ view: plate ? 'Time' : 'Plate', plate: plate || '' })
  }, [plate])

  useEffect(() => {
    socket.current?.on('connect', () => {
      if (qrCodeData.orderId) {
        socket.current.emit('pix', qrCodeData.orderId)
      }
    })

    socket.current?.on('pixpaid', data => {
      setQrCodeData(prev => ({ ...prev, ...data }))
      setValues({ view: 'PixPaid' })

      socket.current?.disconnect()
    })

    if (qrCodeData.orderId) {
      socket.current?.connect()
    }

    return () => {
      socket.current?.off('pixpaid')
      socket.current?.off('connect')
    }
  }, [socket.current, qrCodeData.orderId])

  console.log(settings)
  return (
    <div className="login-wrapper">
      <div className="login-box">
        <div className="logo">
          <Logo isLogin />
        </div>

        <div className="login-title">
          <h3>{`${city.fullName} - ${city.state}`}</h3>
        </div>

        <div>
          {entity.view === 'Plate' && renderPlate(form, route, cityName)}
          {entity.view === 'Time' && renderTime(form, parkWithPix)}
          {entity.view === 'Pix' && renderPix(form, route, qrCodeData, setQrCodeData)}
          {entity.view === 'PixPaid' && renderPixPaid(form, route, modal, qrCodeData, sendEmail)}
        </div>
      </div>

      {(settings.iOSUrl || settings.androidUrl) && (
        <div className="d-flex justify-content-between app-box">
          {settings.iOSUrl && <AppStoreBadge link={settings.iOSUrl} />}
          {settings.androidUrl && <GooglePlayBadge link={settings.androidUrl} />}
        </div>
      )}
    </div>
  )
}
